import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Accueil.css';

const Accueil = () => {
  const sectionTwoRef = useRef(null);
  const sectionThreeRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px'
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !entry.target.classList.contains('animated')) {
          entry.target.classList.add('animated');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    if (sectionTwoRef.current) {
      observer.observe(sectionTwoRef.current);
    }
    if (sectionThreeRef.current) {
      observer.observe(sectionThreeRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="accueil">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="title">Cabinet Ben Nasr, Une Tradition de Savoir Juridique qui se Transmet à Travers les Générations</h1>
          <p className="text">
            Ben Nasr Law Firm est un cabinet d'avocats tunisien fondé sur un héritage de rigueur académique, de plaidoyer judiciaire et d'intégrité professionnelle.
          </p>
          <Link to="/contact" className="btn-primary">Consultation</Link>
          <img
            src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Homepage1.png"
            alt="Hero"
            className="hero-mobile-image"
          />
        </div>
      </section>

      {/* Second Section */}
      <section className="section-two" ref={sectionTwoRef}>
        <div className="section-content">
          <div className="image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Homepage2.png"
              alt="Cabinet"
            />
          </div>
          <div className="text-container">
            <h2 className="title">Une Approche du Droit Fondée sur la Maîtrise et l'Engagement</h2>
            <p className="text">
              Maître Taoufik Ben Nasr, docteur en droit, professeur universitaire émérite et avocat à la cour de cassation, dispose d'une expertise lui permettant d'intervenir dans le cadre du conseil et du contentieux.
              <br /><br />
              Le cabinet poursuit son développement avec la nouvelle génération d'avocats — Mehdi Ben Nasr et Amine Ben Nasr — perpétuant une tradition fondée sur l'excellence juridique et la défense rigoureuse des intérêts de ses clients.
            </p>
            <Link to="/contact" className="btn-primary">Contactez Nous</Link>
          </div>
        </div>
      </section>

      {/* Third Section */}
      <section className="section-three dark-section" ref={sectionThreeRef}>
        <div className="section-content">
          <div className="image-container">
            <img
              src="https://cabinet-ben-nasr.s3.eu-central-1.amazonaws.com/Homepage3.png"
              alt="Affaires juridiques"
            />
          </div>
          <div className="text-container">
            <h2 className="title">Une Approche Stratégique des Affaires Juridiques Complexes</h2>
            <p className="text">
              Le cabinet accompagne particuliers, entreprises, institutions financières et clients internationaux dans la gestion d'affaires juridiques complexes devant les juridictions tunisiennes et dans le cadre de procédures d'arbitrage.
              <br /><br />
              Grâce à une approche alliant analyse juridique approfondie, réflexion stratégique et maîtrise des différentes procédures contentieuses, le cabinet conseille et représente ses clients dans la résolution d'enjeux juridiques et réglementaires en Tunisie.
            </p>
            <Link to="/contact" className="btn-secondary">Contactez-Nous</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Accueil;
